import { relations } from "drizzle-orm/relations";
import { shop_events, durable_jobs, applied_discounts, applied_discount_components, promotions, campaigns, campaign_coupons, campaign_runs, shop_automations, shop_automation_sends, gift_cards, gift_card_transactions, roles, model_has_roles } from "./schema";

export const durable_jobsRelations = relations(durable_jobs, ({one}) => ({
	shop_event: one(shop_events, {
		fields: [durable_jobs.source_event_id],
		references: [shop_events.id]
	}),
}));

export const shop_eventsRelations = relations(shop_events, ({many}) => ({
	durable_jobs: many(durable_jobs),
}));

export const applied_discount_componentsRelations = relations(applied_discount_components, ({one}) => ({
	applied_discount: one(applied_discounts, {
		fields: [applied_discount_components.applied_discount_id],
		references: [applied_discounts.id]
	}),
}));

export const applied_discountsRelations = relations(applied_discounts, ({many}) => ({
	applied_discount_components: many(applied_discount_components),
}));

export const campaignsRelations = relations(campaigns, ({one, many}) => ({
	promotion: one(promotions, {
		fields: [campaigns.promotion_id],
		references: [promotions.id]
	}),
	campaign_coupons: many(campaign_coupons),
	campaign_runs: many(campaign_runs),
}));

export const promotionsRelations = relations(promotions, ({many}) => ({
	campaigns: many(campaigns),
}));

export const campaign_couponsRelations = relations(campaign_coupons, ({one}) => ({
	campaign: one(campaigns, {
		fields: [campaign_coupons.campaign_id],
		references: [campaigns.id]
	}),
	campaign_run: one(campaign_runs, {
		fields: [campaign_coupons.campaign_run_id],
		references: [campaign_runs.id]
	}),
}));

export const campaign_runsRelations = relations(campaign_runs, ({one, many}) => ({
	campaign_coupons: many(campaign_coupons),
	campaign: one(campaigns, {
		fields: [campaign_runs.campaign_id],
		references: [campaigns.id]
	}),
}));

export const shop_automation_sendsRelations = relations(shop_automation_sends, ({one}) => ({
	shop_automation: one(shop_automations, {
		fields: [shop_automation_sends.automation_id],
		references: [shop_automations.id]
	}),
}));

export const shop_automationsRelations = relations(shop_automations, ({many}) => ({
	shop_automation_sends: many(shop_automation_sends),
}));

export const gift_card_transactionsRelations = relations(gift_card_transactions, ({one}) => ({
	gift_card: one(gift_cards, {
		fields: [gift_card_transactions.gift_card_id],
		references: [gift_cards.id]
	}),
}));

export const gift_cardsRelations = relations(gift_cards, ({many}) => ({
	gift_card_transactions: many(gift_card_transactions),
}));

export const model_has_rolesRelations = relations(model_has_roles, ({one}) => ({
	role: one(roles, {
		fields: [model_has_roles.role_id],
		references: [roles.id]
	}),
}));

export const rolesRelations = relations(roles, ({many}) => ({
	model_has_roles: many(model_has_roles),
}));